import {
  issueViewerSecondaryViewQueryKey,
  type IssueViewerSecondaryViewResponse,
} from './fetch-issue-viewer-secondary-view'
import type {IssueDeletionConnection} from './OptionConfig'

export type ParentSecondaryView = IssueViewerSecondaryViewResponse

export function parentSubIssueQueryKey(owner: string, repo: string, number: number) {
  return issueViewerSecondaryViewQueryKey(owner, repo, number)
}

type IssueCoordinates = {owner: string; repo: string; number: number}

export function parentSubIssueDeletionConnection(
  parent: IssueCoordinates,
  child: IssueCoordinates,
  secondaryView: IssueViewerSecondaryViewResponse | undefined,
): IssueDeletionConnection | undefined {
  const issue = secondaryView?.repository?.issue
  if (
    !issue ||
    !issue.subIssues.nodes?.some(
      node =>
        node?.number === child.number &&
        node.repository.owner.login === child.owner &&
        node.repository.name === child.repo,
    )
  ) {
    return undefined
  }

  return {
    ownerId: issue.id,
    connectionPath: ['subIssues'],
    targets: [
      {
        queryKey: issueViewerSecondaryViewQueryKey(parent.owner, parent.repo, parent.number),
        revalidate: true,
        refetchType: 'all',
      },
    ],
  }
}
